import Chart from 'chart.js/auto'
import 'chartjs-adapter-moment'

export default function chart() {
    if(!document.getElementById('perfChart')) {
        return
    }
    const chartCanvas = document.getElementById('perfChart')
    const gradient = chartCanvas.getContext('2d').createLinearGradient(0, 0, 0, 400)
    gradient.addColorStop(.5, 'rgba(168, 68, 218, .4)')
    gradient.addColorStop(1, 'rgba(168, 68, 218, 0)')
    Chart.defaults.color = '#45474d'

    const navPerShareData = JSON.parse(chartCanvas.dataset.navPerShare)
    const sharePricesData = JSON.parse(chartCanvas.dataset.sharePrices)

    const settings = {
        type: 'line',
        data: {
            datasets: [
                {
                    data: navPerShareData,
                    backgroundColor: gradient,
                    label: chartCanvas.dataset.navPerShareLabel,
                    fill: 'start',
                    borderColor: '#a844da',
                    pointBackgroundColor: '#a844da',
                    pointStyle: false,
                },
                {
                    data: sharePricesData,
                    label: chartCanvas.dataset.sharePricesLabel,
                    borderColor: '#0db4fe',
                    pointBackgroundColor: '#0db4fe',
                    pointStyle: false,
                },
            ],
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    display: true,
                    position: 'bottom',
                    usePointStyle: false,
                    labels: {
                        usePointStyle: true,
                        pointStyle: 'rectRounded',
                        pointStyleWidth: 42,
                        boxHeight: 7,
                    },
                },
            },
            scales: {
                x: {
                    type: 'time',
                    time: {
                        unit: 'year',
                    },
                    ticks: {
                        stepSize: 1,
                        callback: function(value) {
                            const date = new Date(value)
                            if (date.getMonth() === 0) {
                                return date.toLocaleString('default', { month: 'short', year: 'numeric' })
                            }
                            return ''
                        },
                    },
                },
                y: {
                    ticks: {
                        callback: function(value) {
                            return value.toFixed(2)
                        },
                    },
                    grid: {
                        color: 'rgba(69, 71, 77, 1)',
                    },
                },
            },
        },
    }
    return new Chart(document.getElementById('perfChart'), settings)
}
